<template>
  <div class="page">
    <Header :activeIndex="3" />
    <!-- about us -->
    <div class="about_box">
      <div class="w">
        <img class="title" src="../assets/images/home/about.png" />
        <div class="content">
          The Company established in 2015, is located in Dongguan, a famous
          machinery production base and an important foreign trade port in
          Guangdong Province,mainly engaged in the production and processing of
          various precision machinery parts. The whole company includes sales,
          finance, engineers and production staff of more than 50 people. The
          factory is 2500 square meters, annual capacity of about 50 million.
          The company is well equipped, with CNC, CNC lathes,common milling
          machines, automatic grinding machines and more than 40sets. After
          several years of development and improvement, the company has mature
          business model, perfect system, exquisite technology, strict
          requirementsfor product quality, think highly of customer service.
        </div>
        <div class="img_box flex3">
          <img class="left" src="../assets/images/about_us/img.png" alt="" />
          <div class="right">
            <div class="name">About SELEAD</div>
            <p>
              Our company has experienced technical personnel, advanced
              processing equipment, perfect management system.We have decades of
              technical experience in processing precision hardware parts. The
              company has good international cooperation resources. Meet the
              customer's personalized service needs. Strive to build ourselves
              as the industry leader of enabling manufacturing.
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- do -->
    <div class="do_box">
      <div class="w">
        <div class="title">What does SELEAD do?</div>
        <p>
          We have rich experience in processing aluminum alloy, copper alloy,
          carbon steel, diamond, stainless steel, silver, copper, brass and
          special engineering plastics. We are good at manufacturing parts with
          complex structure, precision machining different materials and
          different geometric shapes. High precision, high efficiency, good
          dimensional stability, surface quality can be effectively improved. We
          use a variety of the latest equipment can effectively shorten the
          processing process. At the same time, we have integrated the industry
          resources and made use of die casting, powder metallurgy, extrusion
          and other molding materials to reduce the cost of mass production
          products, Each product in the production process has developed a
          detailed processing table.The whole process flow is clear, inspection
          standard, we will also closely control the quality of all aspects of
          production. Accurate dimension inspection report, material certificate
          and heat treatment data report can be provided for all products. We
          will adhere to the concept of creating value for customers and
          society, make use of international advanced hardware equipment and
          many years of European and American customer service experience to
          provide customers with cost-effective, excellent quality and
          considerate service.
        </p>
      </div>
    </div>
    <!-- expect -->
    <div class="expect_box w">
      <div class="title">What can you expect from SELEAD?</div>
      <div class="content">
        <p>
          Our manufacturing process also ensures that each and every one of our
          customers receives a comprehensive solution for any need they may
          have. This includes complex and precision parts, like optical parts,
          automotive parts, medical devices or aerospace parts.No matter how
          complicated your project may be, we can produce what you need.
        </p>
        Our manufacturing process also ensures that each and every one of our
        customers receives a comprehensive solution for any need they may have.
        This includes complex and precision parts, like optical parts,
        automotive parts, medical devices or aerospace parts.No matter how
        complicated your project may be, we can produce what you need.
        <ul>
          <li>Saving money through our low-volume manufacturing process</li>
          <li>Faster time to market (and a higher success rate)</li>
          <li>Creating flexible design options for all your products</li>
          <li>
            Supplying you with a comprehensive option for bridge production
          </li>
        </ul>
        <div class="icons flex1">
          <div class="item">
            <img src="../assets/images/about_us/icon1.png" alt="" />
            <span>Solution Consulting</span>
          </div>
          <div class="item">
            <img src="../assets/images/about_us/icon2.png" alt="" />
            <span>Top Project Management</span>
          </div>
          <div class="item">
            <img src="../assets/images/about_us/icon3.png" alt="" />
            <span>High Quality</span>
          </div>
          <div class="item">
            <img src="../assets/images/about_us/icon4.png" alt="" />
            <span>Time & Money Saving</span>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
export default {
  metaInfo: {
    title: '东莞市乔斯精密机械有限公司',
    meta: [
      {
        name: 'keywords',
        content: '东莞市乔斯精密机械有限公司,乔斯,精密,机械',
      },
      {
        name: 'description', // 设置页面描述
        content: '品质用心、技术创新、恪守信誉、追求完美',
      },
    ],
  },
  components: {
    Header,
    Footer,
  },
}
</script>
<style scoped>
/* about us */
.about_box {
  background: #fff;
  padding: 50px 0;
}
.about_box .title {
  margin: auto;
  width: 319px;
  height: 89px;
  margin-bottom: 18px;
}
.about_box .content {
  color: #3f4a50;
  font-size: 18px;
  line-height: 30px;
  margin-bottom: 30px;
}
.about_box .img_box {
  height: 340px;
}
.about_box .img_box .left {
  height: 340px;
  width: 600px;
}
.about_box .img_box .right {
  flex: 1;
  margin-left: 42px;
  height: 100%;
  font-size: 18px;
  color: #333333;
  line-height: 28px;
}
.about_box .img_box .right .name {
  margin-top: 60px;
  margin-bottom: 54px;
  font-size: 26px;
  color: #333333;
}
/* do */
.do_box {
  background: #f3f3f3;
  padding: 44px 0 80px;
}
.do_box {
  background: #f3f3f3;
  color: #222222;
  font-size: 18px;
}
.title {
  color: #222222;
  font-size: 30px;
  text-align: center;
  margin-bottom: 38px;
}
/* expect */
.expect_box {
  padding: 44px 0 80px;
}
.expect_box .content {
  color: #222222;
  font-size: 18px;
}
.expect_box .content ul {
  margin-left: 15px;
}
.expect_box .content ul li {
  list-style-type: disc;
}
.expect_box .icons {
  margin-top: 50px;
}
.expect_box .icons .item {
  width: 300px;
  margin: 0 40px;
}
.expect_box .icons .item img {
  width: 78px;
  height: 78px;
  margin: auto;
  margin-bottom: 20px;
}
.expect_box .icons .item span {
  display: block;
  width: 100%;
  color: #222222;
  font-size: 18px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/about_us.vue